import { Link } from "react-router-dom";
import { MessageCircle, Phone, Users, MapPin } from "lucide-react";
import { BRAND } from "../lib/brand";

export default function Footer() {
  return (
    <footer
      className="relative bg-[#0a1530] text-white overflow-hidden"
      data-testid="main-footer"
    >
      {/* Mandala bg */}
      <div className="absolute inset-0 mandala-bg opacity-[0.05] pointer-events-none" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#1a2e5a]/40 via-transparent to-[#0a1530] pointer-events-none" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-16 md:py-20">
        {/* CTA block */}
        <div className="text-center mb-14">
          <div className="text-[10px] tracking-[0.32em] uppercase text-[#c9a84c] mb-4">
            Hungry for something real?
          </div>
          <h3 className="font-display text-4xl md:text-6xl font-bold leading-tight">
            Order Now. Eat <span className="text-[#c9a84c] italic">Pure.</span>
          </h3>
          <div className="ornament mt-6 mb-8" aria-hidden="true">
            <span className="text-xs tracking-[0.3em] uppercase">Since With Love</span>
          </div>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a
              href={BRAND.whatsappChat}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-gold"
              data-testid="footer-whatsapp-order"
            >
              <MessageCircle size={18} strokeWidth={2.5} />
              Order on WhatsApp
            </a>
            <a
              href={BRAND.whatsappGroup}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ghost-gold"
              data-testid="footer-whatsapp-group"
            >
              <Users size={18} strokeWidth={2.5} />
              Join WhatsApp Group
            </a>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 pt-12 border-t border-[#c9a84c]/20">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full border-2 border-[#c9a84c] flex items-center justify-center">
                <span className="font-brand text-[#c9a84c] text-xl">A</span>
              </div>
              <div className="font-brand text-2xl">
                Archna's <span className="text-[#c9a84c]">Kitchen</span>
              </div>
            </div>
            <p className="text-white/60 font-body text-sm leading-relaxed max-w-md">
              Home-style tiffins and cloud-kitchen meals cooked with organic
              ingredients, zero adulteration, and the love of a mother's
              kitchen. Freshly prepared daily in Delhi — delivered straight to
              your door.
            </p>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a84c] mb-4">
              Explore
            </div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-white/70 hover:text-[#c9a84c] transition" data-testid="footer-link-home">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/menu" className="text-white/70 hover:text-[#c9a84c] transition" data-testid="footer-link-menu">
                  Menu & Pricing
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-white/70 hover:text-[#c9a84c] transition" data-testid="footer-link-contact">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <div className="text-[10px] tracking-[0.3em] uppercase text-[#c9a84c] mb-4">
              Get in touch
            </div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2 text-white/70">
                <Phone size={14} className="mt-1 text-[#c9a84c]" />
                <a href={`tel:+${BRAND.phoneRaw}`} data-testid="footer-phone" className="hover:text-[#c9a84c] transition">
                  {BRAND.phoneDisplay}
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <MessageCircle size={14} className="mt-1 text-[#c9a84c]" />
                <a
                  href={BRAND.whatsappChat}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#c9a84c] transition"
                  data-testid="footer-whatsapp-chat"
                >
                  WhatsApp Chat
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <Users size={14} className="mt-1 text-[#c9a84c]" />
                <a
                  href={BRAND.whatsappGroup}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-[#c9a84c] transition"
                  data-testid="footer-whatsapp-group-link"
                >
                  WhatsApp Group
                </a>
              </li>
              <li className="flex items-start gap-2 text-white/70">
                <MapPin size={14} className="mt-1 text-[#c9a84c]" />
                <span>Sector 19, Dwarka<br />New Delhi 110075</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <div>© {new Date().getFullYear()} Archna's Kitchen. Cooked with love in Delhi.</div>
          <div className="italic font-display text-[#c9a84c]/80">
            "Ghar jaisa khaana, aapke darwaaze tak."
          </div>
        </div>
      </div>
    </footer>
  );
}
